module.exports = __webpack_public_path__ + "img/still (13).3ce9a547.jpg";